import React, { Component } from 'react';
import { HUNDRED_RATING_OPTIONS } from 'molecules/page-establishment-hundredrating';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';


export default class HundredRatingInfographic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animate: false,
    };
  }

  componentDidMount() {
    requestAnimationFrame(() => {
      this.setState({ animate: true });
    });
  }

  mobileHover(e, type) {
    const { onSubmit } = this.props;
    if (global.isPhone) {
      let targets = [];
      switch (type) {
        case HUNDRED_RATING_OPTIONS.HEART:
          targets = ["hundredicons-icon-heart"];
          onSubmit(HUNDRED_RATING_OPTIONS.HEART);
          break;
        case HUNDRED_RATING_OPTIONS.STAR:
          targets = ["hundredicons-icon-star"];
          onSubmit(HUNDRED_RATING_OPTIONS.STAR);
          break;
        case HUNDRED_RATING_OPTIONS.FIRE:
          targets = ["hundredicons-icon-fire"];
          onSubmit(HUNDRED_RATING_OPTIONS.FIRE);
          break;
        case HUNDRED_RATING_OPTIONS.CENTER: targets = ["hundred-rating-infographic__center", "hundred-rating-infographic__adjective"];
          break;
        default: targets = [];
      }
      targets.forEach((target) => {
        const element = document.querySelector(`.${target}`);
        element.classList.add("-hover-mobile");
        setTimeout(() => {
          element.classList.remove("-hover-mobile");
        }, 1000);
      });
      setTimeout(() => {
        Scroll.animateScroll.scrollTo(document.querySelector(".page-establishment-hundred-rating").offsetTop + 90, {
          delay: 0,
          duration: 500,
          smooth: true,
        });
      }, 100);
    }
  }

  render() {
    const { className, hundredRating, adjective, t } = this.props;
    const { animate } = this.state;
    return (
      <div className={ `hundred-rating-infographic ${className}` }>
        <div className="hundred-rating-infographic__center" onTouchEnd={ e => this.mobileHover(e, HUNDRED_RATING_OPTIONS.CENTER) }>
          <span>
            { hundredRating }
          </span>
        </div>
        <div className="hundred-rating-infographic__outline" />
        <div className="hundred-rating-infographic__dot-container">
          <div className={ `hundred-rating-infographic__dot -heart ${animate ? '-hola' : '-adios'}` } onAnimationEnd={ () => this.setState({ animate: false }) }>
            <div className="hundred-rating-infographic__dot__inner hundredicons-icon-heart" onTouchEnd={ e => this.mobileHover(e, HUNDRED_RATING_OPTIONS.HEART) } />
          </div>
          <div className={ `hundred-rating-infographic__dot -fire ${animate ? '' : '-adios'}` }>
            <div className="hundred-rating-infographic__dot__inner hundredicons-icon-fire" onTouchEnd={ e => this.mobileHover(e, HUNDRED_RATING_OPTIONS.FIRE) } />
          </div>
          <div className={ `hundred-rating-infographic__dot -star  ${animate ? '' : '-adios'}` }>
            <div className="hundred-rating-infographic__dot__inner hundredicons-icon-star" onTouchEnd={ e => this.mobileHover(e, HUNDRED_RATING_OPTIONS.STAR) } />
          </div>
        </div>
        <div className="hundred-rating-infographic__adjective">
          { adjective && t(adjective) }
        </div>
      </div>
    );
  }
}

HundredRatingInfographic.defaultProps = {
  adjective: '',
  className: '',
};

HundredRatingInfographic.propTypes = {
  adjective: PropTypes.string,
  className: PropTypes.string,
  hundredRating: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
